__turbopack_context__.v({
  "loaderContainer": "Sequences-module__xdZvZG__loaderContainer",
  "section": "Sequences-module__xdZvZG__section",
});
